'use client';
import Image from "next/image";
import Link from "next/link";
import styles from "@/app/styles/dine.module.scss";
import useDeviceType from "@/app/utils/useDeviceType";
import Loading from "./loading";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Carousel } from 'react-bootstrap';
import https from "https";
import { useState, useEffect} from "react";

const agent = new https.Agent({
  rejectUnauthorized: false,
});

async function getPageData() {
  const query = `
{
  pageData: pageBy(id: "cG9zdDoxMjY=") {
    dine {
      featuredWineCreativeHeading
      foodSignatureDishesDescription
      foodSignatureDishesMainTitle
      overviewCreativeHeading
      overviewImage {
        node {
          mediaItemUrl
        }
      }
      overviewText
      overviewTitle
      wineCreativeHeading
      wineDescription
      wineMainTitle
      featuredWineImage {
        nodes {
          ... on Qldrink {
            id
            featureddrink {
              featuredImageWinecoll {
                node {
                  mediaItemUrl
                }
              }
            }
            title
          }
        }
      }
      disableFoodSignaturesDishes
      disableWineSection
      foodSignaturesDishesMenu {
        node {
          mediaItemUrl
        }
      }
      wineMenu {
        node {
          mediaItemUrl
        }
      }
      overviewImage2 {
        node {
          mediaItemUrl
        }
      }
      overviewImageSubText
      canapesdishDescription
      canapesdishTitle
      disableDishesCanapes
      canapesdishMenu {
        node {
          mediaItemUrl
        }
      }
    }
    pageBan {
      bannerText
      bannerSlider {
        desktopImage {
          node {
            mediaItemUrl
          }
        }
      }
    }
  }
  qldishes {
    nodes {
      featuredDineDish {
        featureImageDish {
          node {
            mediaItemUrl
          }
        }
      }
      title
    }
  }
  getAllDrinks {
    description
    image
    title
  }
  getAllDrinksWine {
    description
    image
    title
  }
}
  `;

  const res = await fetch(
    `${process.env.NEXT_PUBLIC_GRAPHQL_ENDPOINT}`,
    {
      httpsAgent: agent,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({query}),
      next: {
        revalidate: 60,
      },
    }
  );

  const { data } = await res.json();

  return data;
}

export default function DineWine() {

  const deviceType = useDeviceType();

  const [page_data, setPageData] = useState(null);

  const [page_banner_text, setPageBannerText] = useState("");
  const [page_banner_sliders, setPageBannerSliders] = useState([]);

  const [overview_creative_heading, setOverviewCreativeHeading] = useState("");
  const [overview_heading, setOverviewHeading] = useState("");
  const [overview_description, setOverviewDescription] = useState("");
  const [overview_image, setOverviewImage] = useState("");
  const [overview_imagetwo, setoverviewImage2] = useState("");
  // const [overview_subtitle, setOverviewSubtitle] = useState("");
  // const [overview_subtext, setOverviewSubText] = useState("");
  const [overview_leftpara, setoverviewLeftPara] = useState("");

  const [is_food_disbled, setIsFoodDisabled] = useState(false);
  const [food_creative_heading, setFoodCreativeHeading] = useState("");
  const [food_heading, setFoodHeading] = useState("");
  const [food_description, setFoodDescription] = useState("");
  const [food_list, setFoodList] = useState([]);
  const [food_menu, setFoodMenu] = useState("");

  const [is_drink_disbled, setIsDrinkDisabled] = useState(false);
  const [drink_creative_heading, setDrinkCreativeHeading] = useState("");
  const [drink_heading, setDrinkHeading] = useState("");
  const [drink_description, setDrinkDescription] = useState("");
  const [drink_list, setDrinkList] = useState([]);
  const [drink_menu, setDrinkMenu] = useState("");

  const [is_wine_disbled, setIsWineDisabled] = useState(false);
  const [wine_creative_heading, setWineCreativeHeading] = useState("");
  const [wine_heading, setWineHeading] = useState("");
  const [wine_description, setWineDescription] = useState("");
  const [wine_list, setWineList] = useState([]);
  const [featured_wine_title, setFeaturedWineTitle] = useState("");
  const [featured_wine_name, setFeaturedWineName] = useState("");
  const [featured_image_winecoll, setFeaturedWineImage] = useState("");
  const [wine_menu, setWineMenu] = useState("");
  const [wine_bg_image, setBgImage] = useState("");

  const [is_canapesDish_disbled, setIsDishesCanapesDisabled] = useState(false);
  const [canapesDish_heading, setcanapesDishHeading] = useState("");
  const [canapesDish_description, setcanapesDishDescription] = useState("");
  const [canapesDish_menu, setcanapesDishMenu] = useState("");
  const [canapesDish_list, setcanapesDishList] = useState([]);

  const [pre_loader_enabled, setPreLoaderEnable] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      const page = await getPageData();

      if(page){
        //console.log(page);
        if(page.pageData){
          setPageData(page.pageData);
          if(page.pageData.pageBan){
            if(page.pageData.pageBan.bannerText){
              setPageBannerText(page.pageData.pageBan.bannerText);
            }
            if(page.pageData.pageBan.bannerSlider){
              setPageBannerSliders(page.pageData.pageBan.bannerSlider);
            }
          }

          if(page.pageData.dine){

            if(page.pageData.dine.overviewCreativeHeading){
              setOverviewCreativeHeading(page.pageData.dine.overviewCreativeHeading);
            }
            if(page.pageData.dine.overviewTitle){
              setOverviewHeading(page.pageData.dine.overviewTitle);
            }
            if(page.pageData.dine.overviewText){
              setOverviewDescription(page.pageData.dine.overviewText);
            }
            // if(page.pageData.dine.overviewSubTitle){
            //   setOverviewSubtitle(page.pageData.dine.overviewSubTitle);
            // }
            // if(page.pageData.dine.overviewSubText){
            //   setOverviewSubText(page.pageData.dine.overviewSubText);
            // }
            if(page.pageData.dine.overviewImageSubText){
              setoverviewLeftPara(page.pageData.dine.overviewImageSubText);
            }
            if(page.pageData.dine.overviewImage){
              if(page.pageData.dine.overviewImage.node){
                if(page.pageData.dine.overviewImage.node.mediaItemUrl){
                  setOverviewImage(page.pageData.dine.overviewImage.node.mediaItemUrl);
                }
              }
            }
            if(page.pageData.dine.overviewImage2){
              if(page.pageData.dine.overviewImage2.node){
                if(page.pageData.dine.overviewImage2.node.mediaItemUrl){
                  setoverviewImage2(page.pageData.dine.overviewImage2.node.mediaItemUrl);
                }
              }
            }

            if(page.pageData.dine.disableFoodSignaturesDishes){
              setIsFoodDisabled(page.pageData.dine.disableFoodSignaturesDishes);
            }
            if(page.pageData.dine.foodSignatureDishesCreativeHeading){
              setFoodCreativeHeading(page.pageData.dine.foodSignatureDishesCreativeHeading);
            }
            if(page.pageData.dine.foodSignatureDishesMainTitle){
              setFoodHeading(page.pageData.dine.foodSignatureDishesMainTitle);
            }
            if(page.pageData.dine.foodSignatureDishesDescription){
              setFoodDescription(page.pageData.dine.foodSignatureDishesDescription);
            }
            if(page.pageData.dine.foodSignaturesDishesMenu){
              if(page.pageData.dine.foodSignaturesDishesMenu.node){
                if(page.pageData.dine.foodSignaturesDishesMenu.node.mediaItemUrl){
                  setFoodMenu(page.pageData.dine.foodSignaturesDishesMenu.node.mediaItemUrl);
                }
              }
            }
            





            if(page.pageData.dine.disableDishesCanapes){
              setIsDishesCanapesDisabled(page.pageData.dine.disableDishesCanapes);
            }
            if(page.pageData.dine.canapesdishTitle){
              setcanapesDishHeading(page.pageData.dine.canapesdishTitle);
            }
            if(page.pageData.dine.canapesdishDescription){
              setcanapesDishDescription(page.pageData.dine.canapesdishDescription);
            }
            if(page.pageData.dine.canapesdishMenu){
              if(page.pageData.dine.canapesdishMenu.node){
                if(page.pageData.dine.canapesdishMenu.node.mediaItemUrl){
                  setcanapesDishMenu(page.pageData.dine.canapesdishMenu.node.mediaItemUrl);
                }
              }
            }
            if(page.qldishes){
              if(page.qldishes.nodes){
                setcanapesDishList(page.qldishes.nodes);
              }
            }





            if(page.pageData.dine.disableFoodSignaturesDishes){
              setIsDrinkDisabled(page.pageData.dine.disableFoodSignaturesDishes);
            }
            if(page.pageData.dinedrinkSignaturesDrinksCreativeHeading){
              setDrinkCreativeHeading(page.pageData.dine.drinkSignaturesDrinksCreativeHeading);
            }
            if(page.pageData.dine.drinkSignaturesDrinksMainTitle){
              setDrinkHeading(page.pageData.dine.drinkSignaturesDrinksMainTitle);
            }
            if(page.pageData.dine.drinkSignaturesDrinksDescription){
              setDrinkDescription(page.pageData.dine.drinkSignaturesDrinksDescription);
            }
            if(page.pageData.dine.drinkSignaturesDrinksMenu){
              if(page.pageData.dine.drinkSignaturesDrinksMenu.node){
                if(page.pageData.dine.drinkSignaturesDrinksMenu.node.mediaItemUrl){
                  setDrinkMenu(page.pageData.dine.drinkSignaturesDrinksMenu.node.mediaItemUrl);
                }
              }
            }
            if(page.getAllDrinks){
              setDrinkList(page.getAllDrinks);
            }

            if(page.pageData.dine.disableWineSection){
              setIsWineDisabled(page.pageData.dine.disableWineSection);
            }
            if(page.pageData.dine.wineCreativeHeading){
              setWineCreativeHeading(page.pageData.dine.wineCreativeHeading);
            }
            if(page.pageData.dine.wineMainTitle){
              setWineHeading(page.pageData.dine.wineMainTitle);
            }
            if(page.pageData.dine.wineDescription){
              setWineDescription(page.pageData.dine.wineDescription);
            }
            if(page.pageData.dine.featuredWineCreativeHeading){
              setFeaturedWineTitle(page.pageData.dine.featuredWineCreativeHeading);
            }
            if(page.pageData.dine.featuredWineImage){
              if(page.pageData.dine.featuredWineImage.nodes){
                if(page.pageData.dine.featuredWineImage.nodes[0]){

                  if(page.pageData.dine.featuredWineImage.nodes[0].title){
                    setFeaturedWineName(page.pageData.dine.featuredWineImage.nodes[0].title);
                  }
                  if(page.pageData.dine.featuredWineImage.nodes[0].featureddrink){
                    if(page.pageData.dine.featuredWineImage.nodes[0].featureddrink.featuredImageWinecoll){
                      if(page.pageData.dine.featuredWineImage.nodes[0].featureddrink.featuredImageWinecoll.node){
                        if(page.pageData.dine.featuredWineImage.nodes[0].featureddrink.featuredImageWinecoll.node.mediaItemUrl){
                          setFeaturedWineImage(page.pageData.dine.featuredWineImage.nodes[0].featureddrink.featuredImageWinecoll.node.mediaItemUrl);
                        }
                      }
                    }
                  }
                }
              }
            }
            if(page.getAllDrinksWine){
              setWineList(page.getAllDrinksWine);
            }
            if(page.pageData.dine.wineMenu){
              if(page.pageData.dine.wineMenu.node){
                if(page.pageData.dine.wineMenu.node.mediaItemUrl){
                  setWineMenu(page.pageData.dine.wineMenu.node.mediaItemUrl);
                }
              }
            }
            if(page.pageData.dine.wineBackgroundImage){
              if(page.pageData.dine.wineBackgroundImage.node){
                if(page.pageData.dine.wineBackgroundImage.node.mediaItemUrl){
                  setBgImage(page.pageData.dine.wineBackgroundImage.node.mediaItemUrl);
                }
              }
            }
          }
        }
        setPreLoaderEnable(false);
      }
    };

    fetchData();
    return () => {};
  }, []);

  useEffect( () => {
    (
      async () => {
          const LocomotiveScroll = (await import('locomotive-scroll')).default
          const locomotiveScroll = new LocomotiveScroll();
      }
    )()
  }, [])

  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    focusOnSelect: true,
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 3000,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const settingsdrink = {
    dots: false,
    arrows: false,
    infinite: drink_list.length > 2,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    focusOnSelect: true,
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 3000,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          arrows:true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const settingswine = {
    dots: true,
    arrows: true,
    infinite:  true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    focusOnSelect: true,
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 3000,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const settingsDishDine = {
    dots: false,
    arrows: true,
    infinite:  true,
    slidesToShow: 1,
    slidesToScroll: 1,
   autoplay: true,
   autoplaySpeed: 5000,
    focusOnSelect: true,
    pauseOnHover: false,
  };

  if (pre_loader_enabled) {
    return <Loading />;
  }

  return (
    <>
 {page_banner_sliders && page_banner_sliders.length !== 0 &&(
      <section className="mainBanner inner-banner position-relative">
        <Carousel fade className='page-inner-carousel'>
        {page_banner_sliders.map((banner_img, index) => {

          let imgurl = '';

          if(banner_img.desktopImage){
            if(banner_img.desktopImage.node){
              if(banner_img.desktopImage.node.mediaItemUrl){
                imgurl = banner_img.desktopImage.node.mediaItemUrl;
              }
            }
          }

          return(
          <Carousel.Item key={index}>
            <Image
              className={styles.banner_section_main_img}
              src={imgurl}
              width={deviceType !== "mobile" ? 1920 : 400}
              height={deviceType !== "mobile" ? 1080 : 800}
              alt="Banner Image"
              priority
              quality={deviceType !== "mobile" ? 50 : 80}
            />
          </Carousel.Item>
          );}
          )}
        </Carousel>
        <div className='inner-banner-text'>
          <h2 className='all-caps section-heading-large section-heading--yellow'>{page_banner_text}</h2>
        </div>
      </section>
      )}

      {page_banner_sliders && page_banner_sliders.length === 0 &&(
      <section className="bg-dark-green green-mesh  inner-banner-text-wrap position-relative">
        <div className='inner-banner-text'>
          <h2 className='all-caps section-heading-large section-heading--yellow m-0'>{page_banner_text}</h2>
        </div>
      </section>
      )}








  {/* new design */}

      <section className={`bg-layoutImage bg-dark-green green-mesh ${styles.indulgeSection}`}>
          <div className="main-wrapper">
              <div className={styles.indulgePreper}>
                <h6 className="creative-heading-small creative-heading--white all-caps para-light">
                  {overview_creative_heading}
                </h6>
                <h1 className="section-heading creative-heading--white heading-padding lspace-2-52 all-caps p-b-i-90">
                  {overview_heading}
                </h1>
              </div>
              <div className={`d-flex ${styles.indulgeParaImage}`}>
                  <div className={styles.leftImgeParaIndulge}>
                    <p className={`paragraph paragraph--white heading-padding ${styles.paraindulImg}`}>
                      {overview_description}
                    </p>
                   <div className={`d-flex ${styles.imagewithPara}`}>
                    <Image
                          className={`w-100 ${styles.dine_welcome_img_one} ${styles.dine_welcome_img_overview}`}
                          src={overview_image}
                          width={deviceType !== "mobile" ? 555 : 360}
                          height={deviceType !== "mobile" ? 515 : 400}
                          alt="Banner Image"
                          quality={deviceType !== "mobile" ? 50 : 80}
                      />
                      <div className={`all-caps para-light paragraph--whiteTxt heading-padding ${styles.overview_image_subtext}`}>
                        {overview_leftpara}
                      </div>
                   </div>
                  </div>
                  <div className={styles.rightParaImage}>
                    <Image
                          className={`w-100 ${styles.dine_welcome_img_two} ${styles.dine_welcome_img_overview}`}
                          src={overview_imagetwo}
                          width={deviceType !== "mobile" ? 620 : 360}
                          height={deviceType !== "mobile" ? 715 : 400}
                          alt="Banner Image"
                          quality={deviceType !== "mobile" ? 50 : 80}
                      />
                  </div>
              </div>
          </div>
      </section>

      {!is_food_disbled &&(
      <>
        <section className={`bg-layoutImage bg-dark-green ${styles.SignatureCocktail} green-mesh`}>
          <div className="main-wrapper">
            <div className={styles.wrapperCocktails}>
              <div className={styles.cocktailshead}>
                  <h2 className="text-center section-heading creative-heading--white heading-padding lspace-2-52 all-caps p-b-i-60">
                    {food_heading}
                  </h2>
                  <p className={`text-center paragraph paragraph--white ${styles.w_1160}`}>
                    {food_description}
                  </p>                  
              </div>
             
                {food_menu &&(
                  <div className={`${styles.downlodMenu}`}>
                    <div className='d-flex z-top button-menu justify-content-center'>
                      <a
                          target="_blank"
                          className={`${styles.download_menu} next-btn next-btn--yellow`}
                          href={food_menu}
                        >
                          <span className={`all-caps ${styles.span_menuName}`} >download menu</span>
                          <Image
                            src="/down-arr-w.png"
                            width={15}
                            height={10}
                            alt="Down arrow"
                          />
                        </a>
                    </div>
                  </div>
                )}
              
            </div>
            <div className={styles.postCocktailWrapper}>
              <Slider className={`inner-dish-slider black-slider-dots ${styles.inner_dish_slider}`} {...settingsdrink}>
                {drink_list.map((drink_item, index) => {
                  return(
                    <div className={styles.inner_dish_slider_div} key={index}>
                      <div className={`${styles.dish_box} ${styles.drink_box} dish_box`}>
                        <div className={styles.dish_box__imageF}>
                          <Image
                            className="imagewinefeature"
                            src={drink_item.image}
                            width={deviceType !== "mobile" ? 550 : 400}
                            height={deviceType !== "mobile" ? 650 : 400}
                            alt="Banner Image"
                            quality={deviceType !== "mobile" ? 100 : 80}
                          />
                        </div>
                        <div className={styles.dish_box__content}>
                          <h6 className={`${styles.title_heading} title-heading--white heading-padding`}>{drink_item.title}</h6>
                        </div>
                      </div>
                    </div>
                  );
                }
                )}
              </Slider>
            </div> 
          </div>
        </section>
      </>
      )}

      {!is_wine_disbled &&(
        <>
          <section className={`section-padding-bottom section-padding-top bg-dark-green green-mesh  position-relative ${styles.sectionWine}`}>
            <div className={`main-wrapper flex-wrap d-flex justify-content-between z-top position-relative ${styles.j_center}`}>
              <div className={styles.featured_half}>
                <div className='position-relative'>
                  <Image
                    className={`w-100 ${styles.dine_welcome_img_F}`}
                    src={featured_image_winecoll}
                    width={deviceType !== "mobile" ? 560 : 360}
                    height={deviceType !== "mobile" ? 760 : 400}
                    alt="Banner Image"
                    quality={deviceType !== "mobile" ? 50 : 80}
                  />
                  <div className={styles.drink_feature_text}>
                    <div className={styles.wrap_wineF}>
                      <h6 className={styles.featured_heading}>
                        featured wine
                      </h6>
                      <h2
                      className={`${styles.title_heading} title-heading--white heading-padding`}>
                       {featured_wine_name}
                      </h2> 
                    </div>
                  </div>
                </div>
              </div>
              <div className={`${styles.featured_righthalf} half-div half-div-mobile-padding d-flex align-items-center`}>
                <div className={styles.rightwrap_coll}>
                  <h2 className="text-left section-heading creative-heading--white heading-padding lspace-2-52 all-caps">
                    {wine_heading}
                  </h2>
                  <p className={`${styles.winepara} paragraph paragraph--white tab-text-left`}>
                  {wine_description}
                  </p>
                  {drink_menu &&(
                  <div className={`${styles.downlodMenu} ${styles.mobileOnly} d-none`}>
                    
                        <div className='d-flex z-top button-menu justify-content-center'>
                          <a
                              target="_blank"
                              className={`${styles.download_menu} next-btn next-btn--yellow`}
                              href={drink_menu}
                            >
                              <span className={`all-caps ${styles.span_menuName}`} >download menu</span>
                              <Image
                                src="/down-arr-w.png"
                                width={15}
                                height={10}
                                alt="Down arrow"
                              />
                            </a>
                        </div>
                  </div>
                  )}
                  <div className={styles.wrapperWineSlider}>
                    <Slider className={`inner-dish-slider arrow-dish ${styles.inner_dish_slider_wine}`} {...settingswine}>
                      {wine_list.map((wine_item, index) => {
                        return(
                        <div className={styles.inner_dish_slider_div} key={index}>
                          <div className={`${styles.dish_boxx} ${styles.drink_box} dish_box`}>
                            <div className={`position-relative ${styles.dish_box__imageCol}`}>
                              <Image
                                className={styles.ImageWineCollect}
                                src={wine_item.image}
                               
                                width={deviceType !== "mobile" ? 350 : 400}
                                height={deviceType !== "mobile" ? 470 : 400}
                                alt="Banner Image"
                                quality={deviceType !== "mobile" ? 100 : 80}
                              />
                              <div className={styles.drink_feature_text}>
                                  <h6 className={`${styles.title_heading} title-heading--white heading-padding`}>{wine_item.title}</h6>
                              </div>
                            </div>                            
                          </div>
                        </div>
                        );}
                      )}
                    </Slider> 
                  </div>
                </div>
                {wine_menu &&(
                  <div className={`${styles.downlodMenu} ${styles.desktopOnly}`}>                  
                      <div className='d-flex z-top button-menu justify-content-center'>
                        <a
                            target="_blank"
                            className={`${styles.download_menu} next-btn next-btn--yellow`}
                            href={wine_menu}
                          >
                            <span className={`all-caps ${styles.span_menuName}`} >download menu</span>
                            <Image
                              src="/down-arr-w.png"
                              width={15}
                              height={10}
                              alt="Down arrow"
                            />
                          </a>
                      </div>                  
                  </div>
                )}
              </div>
             
            </div>
          </section>
        </>
      )}

      {!is_canapesDish_disbled &&(
        <section className={`${styles.canapesDish} canapesDish bg-dark-meroon green-mesh position-relative`}>
          <Image className={styles.imageDishBG} src="/dishBG.png" width={465} height={996} alt="imageDishBG"/>
          <div className="middle-wrap">
              <div className={`${styles.wrapCanapes} d-flex`}>
                  <div className={styles.leftDishWrap}>
                    <h2 className="text-left section-heading creative-heading--white heading-padding lspace-2-52 all-caps">
                      {canapesDish_heading}
                    </h2>
                    <p className={`${styles.Dishpara} paragraph paragraph--white tab-text-left`}>
                    {canapesDish_description}
                    </p>
                    {canapesDish_menu &&(
                      <div className={styles.downlodMenuDish}>                      
                          <div className='d-flex z-top button-menu justify-content-center'>
                            <a
                                target="_blank"
                                className={`${styles.download_menu} next-btn next-btn--yellow`}
                                href={canapesDish_menu}
                              >
                                <span className={`all-caps ${styles.span_menuName}`} >download menu</span>
                                <Image
                                  src="/down-arr-w.png"
                                  width={15}
                                  height={10}
                                  alt="Down arrow"
                                />
                              </a>
                          </div>
                      </div>
                    )}
                  </div>
                  <div className={styles.rightDishWrap}>
                    <Slider className={`inner-dish-slider arrow-canapes ${styles.inner_dish_slider_Dish}`} {...settingsDishDine}>
                      {canapesDish_list.map((dish_item, index) => {
                        let imgurl = "";
          
                        if(dish_item.featuredDineDish){
                          if(dish_item.featuredDineDish.featureImageDish){
                            if(dish_item.featuredDineDish.featureImageDish.node){
                              if(dish_item.featuredDineDish.featureImageDish.node.mediaItemUrl){
                                imgurl = dish_item.featuredDineDish.featureImageDish.node.mediaItemUrl;
                              }
                            }
                          }
                        }
                        return(
                        <div className={styles.inner_dish_slider_div} key={index}>
                          <div className={`${styles.dish_boxx} ${styles.drink_box} dish_box`}>
                            <div className={`position-relative ${styles.dish_box__imageCol}`}>
                              <Image
                                className={styles.ImageDishCollect}
                                src={imgurl }
                                width={deviceType !== "mobile" ? 350 : 400}
                                height={deviceType !== "mobile" ? 470 : 400}
                                alt="Banner Image"
                                quality={deviceType !== "mobile" ? 100 : 80}
                              />                              
                            </div>
                            <div className={styles.dish_text}>
                                <h6 className={`${styles.dishtitle_heading} title-heading--white heading-padding`}>{dish_item.title}</h6>
                            </div>                            
                          </div>
                        </div>
                        );}
                      )}
                    </Slider>
                  </div>
              </div>
          </div>
        </section>
      )}


      {/* end new design */}
    </>
  )
}
